<div #stepper class="stepper">
  <div #step class="step"></div>
  <div #step class="step"></div>
  <div #step class="step"></div>
  <div #step class="step"></div>
  <div #step class="step"></div>
  <div #step class="step"></div>
  <div #step class="step"></div>
</div>